export interface Review {
  id: string;
  name: string;
  role: string;
  avatar: string;
  content: string;
  hasPhoto?: boolean;
  photoImage?: string;
}

export const reviews: Review[] = [
  {
    id: "1",
    name: "张先生",
    role: "媒体从业者",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20headshot%20portrait%2C%20simple%20warm%20background%2C%20business%20casual%20style%2C%20clean%20minimal%20composition%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-01&orientation=squarish",
    content: "做媒体这么多年，51黑料网是我见过最敢说真话的平台。很多信息都是从别的地方看不到的，时效性也非常强。已经推荐给身边所有同事了。",
  },
  {
    id: "2",
    name: "李女士",
    role: "互联网从业者",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20headshot%20portrait%2C%20simple%20warm%20background%2C%20modern%20style%2C%20clean%20composition%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-02&orientation=squarish",
    content: "每天上班第一件事就是刷51黑料网，信息密度很高，不是那种标题党。科技板块的内容尤其有深度，很多行业内部消息都是在这里首发。",
  },
  {
    id: "3",
    name: "王同学",
    role: "大学生",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20headshot%20portrait%2C%20simple%20warm%20background%2C%20casual%20style%2C%20clean%20composition%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-03&orientation=squarish",
    content: "室友推荐给我的，一开始只是看娱乐八卦消遣，后来发现社会热点板块也做得很好。很多新闻事件的分析角度很独特，能学到很多东西。",
    hasPhoto: true,
    photoImage: "https://readdy.ai/api/search-image?query=Young%20Chinese%20university%20student%20reading%20on%20phone%20in%20modern%20campus%2C%20warm%20natural%20light%2C%20casual%20atmosphere%2C%20editorial%20style%20photography%2C%20clean%20composition%2C%20soft%20background%20bokeh&width=600&height=400&seq=review-photo-01&orientation=landscape",
  },
  {
    id: "4",
    name: "赵经理",
    role: "金融分析师",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20businessman%20headshot%20portrait%2C%20simple%20warm%20background%2C%20formal%20business%20style%2C%20clean%20composition%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-04&orientation=squarish",
    content: "作为金融从业者，对信息的准确性和时效性要求很高。51黑料网在社会经济类新闻方面的报道经常领先主流媒体，这一点非常难得。",
  },
  {
    id: "5",
    name: "陈姐",
    role: "全职妈妈",
    avatar: "https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20woman%20headshot%20portrait%2C%20simple%20warm%20background%2C%20casual%20elegant%20style%2C%20clean%20composition%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-05&orientation=squarish",
    content: "本来是看娱乐八卦来的，结果发现这个平台不只是八卦，还有很多社会正能量和深度调查。现在每天都会花一两个小时在这里看文章。",
    hasPhoto: true,
    photoImage: "https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20woman%20using%20tablet%20at%20home%2C%20warm%20cozy%20living%20room%20background%2C%20natural%20window%20light%2C%20casual%20lifestyle%20photography%2C%20clean%20composition%2C%20relaxed%20atmosphere&width=600&height=400&seq=review-photo-02&orientation=landscape",
  },
];